import { Section } from "./Section";
import { BETS } from "@/content/landing";

export function Bets() {
  return (
    <Section
      id="why"
      testId="landing-bets"
      eyebrow={BETS.eyebrow}
      title={BETS.title}
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
        {BETS.cards.map((c, i) => (
          <article
            key={c.n}
            data-testid={`landing-bet-card-${i}`}
            className="relative flex flex-col rounded-2xl border border-border/60 bg-card/60 p-7 transition-colors hover:border-primary/40"
          >
            <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
              bet {c.n}
            </span>
            <h3 className="mt-4 text-xl font-semibold leading-snug text-foreground sm:text-2xl">
              {c.title}
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
              {c.body}
            </p>
            <div
              aria-hidden="true"
              className="mt-6 h-px w-12 bg-gradient-to-r from-accent to-primary"
            />
          </article>
        ))}
      </div>
    </Section>
  );
}
